"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventCopyActionStatus = void 0;
var EventCopyActionStatus;
(function (EventCopyActionStatus) {
    EventCopyActionStatus["InQueue"] = "InQueue";
    EventCopyActionStatus["Processing"] = "Processing";
    EventCopyActionStatus["Completed"] = "Completed";
    EventCopyActionStatus["Failed"] = "Failed";
})(EventCopyActionStatus = exports.EventCopyActionStatus || (exports.EventCopyActionStatus = {}));
//# sourceMappingURL=event-action-view-model.js.map